<div class="pdf-container">

    <div class="header">
        <div class="logo">
            <img src="../../../../assets/images/logoesign.png" alt="Company Logo" />
        </div>
        <div class="title">AUDIT TRAIL</div>
    </div>


    <div class="doc-detail">
        <div class="field">
            <div class="key">Document Name</div>
            <div class="value">
                {{ auditTrailData.document.documentName }}
            </div>
        </div>

        <div class="field">
            <div class="key">Document ID(s)</div>
            <div class="value">
                {{ auditTrailData.document.documentId }}
            </div>   
        </div>

        <div class="field">
            <div class="key">Document Hash</div>
            <div class="value hash">
                {{ auditTrailData.document.documentHash }}
            </div>
        </div>

        <div class="field">
            <div class="key">Status</div>
            <div class="value bold">
                {{ auditTrailData.document.status }}
            </div>
        </div>
    </div>

    <div class="doc-detail">
        <div class="field">
            <div class="key">Stamp Details</div>
            <div class="value">
                <p> <span>State:</span> {{ auditTrailData.stampDetails.state }}</p>
                <p> <span>Total Stamp Amount:</span> {{ auditTrailData.stampDetails.totalStampAmount }}</p>
                <p><span>Serial Number(s):</span> {{ auditTrailData.stampDetails.serialNumbers.join(', ') }}</p>
            </div>
        </div>
    </div>

    <!-- SIGNING SENTENCE -->
    <div class="signed-text">
        This document has been signed through <span class="bold">Avss.com</span>.
    </div>

    <!-- AUDIT LOG TABLE -->
    <div class="table-responsive">
    <table class="audit-table">
        <thead>
            <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th>Date</th>
                <th>Details</th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let row of auditTrailData.auditTrail">
                <td>{{ row.srNo }}</td>

                <td>
                    <div class="bold">{{ row.name }}</div>
                    <div class="sub" *ngIf="row.email">{{ row.email }}</div>
                    <div class="sub" *ngIf="row.mobile">{{ row.mobile }}</div>
                </td>

                <td>{{ row.dateTimeIST }}</td>

                <td>
                    <div>
                        <span class="bold">IP:</span> {{ row.ipAddress }}
                    </div>

                    <div>
                        <span class="bold">Activity:</span> {{ row.activity }}
                    </div>


                    <div class="block-box">
                        <span class="bold">Live Photo:</span>
                        <img src="../../../../assets/images/logoesign.png" alt="Company Logo" />
                    </div>
                    <div>
                        <span class="bold">OS:</span> Mac OS X, <span class="bold">Browser:</span> Chrome, <span
                            class="bold">Device:</span>
                        Other
                    </div>
                    <div class="block-box" *ngIf="row?.location">
                        <span class="bold">Location Captured:</span>
                        <div class="detail">
                            <div>
                                <span class="bold">Latitude:</span>
                                {{ row.location.latitude }} | <span class="bold">Longitude:</span>
                                {{ row.location.longitude }}
                            </div>
                            <div>
                                <span class="bold">Address:</span>
                                {{ row.location.address }}
                            </div>
                            <div>
                                <span class="bold">AccuracyMeters:</span>
                                {{ row.location.accuracyMeters }}
                            </div>
                        </div>
                    </div>

                    <div class="block-box" *ngIf="row?.signature">
                        <span class="bold">Certificate Details:</span>
                        <div class="detail">
                            <div *ngIf="row?.signature?.transactionId">
                                <span class="bold">Transaction ID:</span>
                                {{ row.signature.transactionId }}
                            </div>

                            <div *ngIf="row?.signature?.authenticationType">
                                <span class="bold">Authentication Type:</span>
                                {{ row.signature.authenticationType }}
                            </div>

                            <div *ngIf="row?.signature?.certificate?.name">
                                <span class="bold">Name:</span>
                                {{ row.signature.certificate.name }}
                            </div>

                            <div *ngIf="row?.signature?.certificate?.pincode">
                                <span class="bold">Pincode:</span>
                                {{ row.signature.certificate.pincode }},
                                <span class="bold">State:</span>
                                {{ row.signature.certificate.state }}
                            </div>

                            <div *ngIf="row?.signature?.certificate">
                                <span class="bold">Gender:</span>
                                {{ row.signature.certificate.gender }} |
                                <span class="bold">YOB:</span>
                                {{ row.signature.certificate.yearOfBirth }}
                            </div>

                            <div *ngIf="row?.signature?.certificate?.serialNo">
                                <span class="bold">Serial No:</span>
                                {{ row.signature.certificate.serialNo }}
                            </div>

                            <div *ngIf="row?.signature?.certificate?.issuer">
                                <span class="bold">Issuer:</span>
                                {{ row.signature.certificate.issuer }}
                            </div>

                            <div *ngIf="row?.signature?.certificate?.organization">
                                <span class="bold">Organization:</span>
                                {{ row.signature.certificate.organization }}
                            </div>

                            <div *ngIf="row?.signature?.certificate?.validityStart">
                                <span class="bold">Validity Start:</span>
                                {{ row.signature.certificate.validityStart }}
                            </div>

                            <div *ngIf="row?.signature?.certificate?.validityEnd">
                                <span class="bold">Validity End:</span>
                                {{ row.signature.certificate.validityEnd }}
                            </div>
                        </div>
                    </div>







                </td>
            </tr>
        </tbody>
    </table>
    </div>

    <div class="signed-text">
        <span class="bold">Consent Provided:</span> By clicking this checkbox and the eSign button, I voluntarily agree
        to Aadhaar eSign the previewed document. I also agree to be redirected to an eSign Service Provider for carrying
        out an eauthentication using Aadhaar e-KYC services for issuance of a Digital Signature Certificate. I agree to
        accept such Certificate for its affixation to the previewed document.
    </div>

</div>